import { createRoute } from "@tanstack/react-router";
import { useState } from "react";

import { usePortalMe } from "../../api/portal.js";
import { PortalHomeHub } from "../../components/portal/portal-home-hub.js";
import { PortalOrientation } from "../../components/portal/portal-orientation.js";
import { Transition33Welcome } from "../../components/portal/transition33-welcome.js";
import { brandForPartner } from "../../lib/partner-brand.js";
import { isOrientationSeen, markOrientationSeen } from "../../lib/portal-copy.js";
import { portalRoute } from "../_portal.js";

/**
 * Portal Overview — welcome → orientation → attention-first job hub.
 *
 * GoP (Transition33) guests see the full-screen welcome once per session,
 * then a one-screen orientation, then the job hub. Other partners skip
 * welcome but still get orientation on first Overview visit in-session.
 */
export const portalIndexRoute = createRoute({
  getParentRoute: () => portalRoute,
  path: "/portal",
  component: PortalLanding,
});

function PortalLanding() {
  const meQuery = usePortalMe();

  const [entered, setEntered] = useState(() => {
    try {
      return sessionStorage.getItem("t33WelcomeEntered") === "1";
    } catch {
      return false;
    }
  });

  const [orientationSeen, setOrientationSeen] = useState(() => {
    try {
      return isOrientationSeen(sessionStorage);
    } catch {
      return false;
    }
  });

  const brand = brandForPartner(meQuery.data?.tenantSlug);
  const isTransition33 = brand.kind === "transition33";

  if (isTransition33 && !entered) {
    return (
      <Transition33Welcome
        name={meQuery.data?.name || undefined}
        onEnter={() => {
          try {
            sessionStorage.setItem("t33WelcomeEntered", "1");
          } catch {
            /* sessionStorage unavailable */
          }
          setEntered(true);
        }}
      />
    );
  }

  if (!orientationSeen) {
    return (
      <PortalOrientation
        isTransition33={isTransition33}
        onContinue={() => {
          markOrientationSeen(sessionStorage);
          setOrientationSeen(true);
        }}
      />
    );
  }

  return <PortalHomeHub />;
}
